import axios from 'axios'
const baseurl = process.env.REACT_APP_API_URL

export const addUserAddress = async (data, token) => {
  const res = await axios({
    method: 'post',
    url: baseurl + `/addAddress`,
    headers: {
      token: token
    },
    data: data
  })
}

export const getUserAddress = async token => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/getAddress`,
    headers: {
      token: token
    }
  })

  return res.data.data
}
export const deleteUserAddress = async (addressId, token) => {
  const res = await axios({
    method: 'post', // matches your backend
    url: baseurl + `/deleteAddress`,
    headers: {
      token: token
    },
    data: {
      addressId // send addressId in body
    }
  })
  return res.data
}

export const order = async (data, token) => {
  const res = await axios({
    method: 'post',
    url: baseurl + `/createOrder`,
    data: data,
    headers: {
      token: token
    }
  })
  return res.data
}
